module.exports = __webpack_public_path__ + "static/media/04saikyou.b40c465a.png";